// extracted by mini-css-extract-plugin
export default {"container":"list-header-view_container__tZZ-7"};